
  export default {
    props: {
      disabled: { type: Boolean, default: false },
      text: { type: String, required: true },
      type: { type: String, default: 'submit' }
    },
    data () {
      return {
        icon: null
      };
    },
    methods: {
      showSuccess () {
        this.icon = 'check';
        setTimeout(() => {
          this.icon = null;
        }, 1500);
      }
    }
  };
